export var DateTimeParts;
(function (DateTimeParts) {
    DateTimeParts["dayOfMonth"] = "dayOfMonth";
    DateTimeParts["dayOfMonthOrdinal"] = "dayOfMonthOrdinal";
    DateTimeParts["dayOfWeekLong"] = "dayOfWeekLong";
    DateTimeParts["dayOfWeekLongUppercase"] = "dayOfWeekLongUppercase";
    DateTimeParts["dayOfWeekShort"] = "dayOfWeekShort";
    DateTimeParts["dayOfWeekShortUppercase"] = "dayOfWeekShortUppercase";
    DateTimeParts["dayOfWeekLongPropercase"] = "dayOfWeekLongPropercase";
    DateTimeParts["dayOfWeekShortPropercase"] = "dayOfWeekShortPropercase";
    DateTimeParts["lastDayOfWeekLong"] = "lastDayOfWeekLong";
    DateTimeParts["monthNumber"] = "monthNumber";
    DateTimeParts["monthLong"] = "monthLong";
    DateTimeParts["monthLongUppercase"] = "monthLongUppercase";
    DateTimeParts["monthShort"] = "monthShort";
    DateTimeParts["monthShortUppercase"] = "monthShortUppercase";
    DateTimeParts["monthLongPropercase"] = "monthLongPropercase";
    DateTimeParts["monthShortPropercase"] = "monthShortPropercase";
    DateTimeParts["time"] = "time";
})(DateTimeParts || (DateTimeParts = {}));
//# sourceMappingURL=types.js.map